import Vue from "vue";

import AccountLogin from "@Scripts/Components/Account/AccountLogin.vue";
import AccountLogout from "@Scripts/Components/Account/AccountLogout.vue";
import AccountRegister from "@Scripts/Components/Account/AccountRegister.vue";
import AccountEdit from "@Scripts/Components/Account/AccountEdit.vue";
import AccountEmailConfirmSend from "@Scripts/Components/Account/AccountEmailConfirmSend.vue";
import AccountPasswordRemind from "@Scripts/Components/Account/AccountPasswordRemind.vue";
import AccountPasswordReset from "@Scripts/Components/Account/AccountPasswordReset.vue";
import AccountExternalRegister from "@Scripts/Components/Account/AccountExternalRegister.vue";

import AccountProfileEdit from "@Scripts/Components/Account/AccountProfileEdit.vue";

import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";
import InfoRequest from "@Scripts/Components/InfoRequest/InfoRequest.vue";
import InfoRequestCta from "@Scripts/Components/InfoRequest/InfoRequestCta.vue";
import ProductDetailAdd from "@Scripts/Components/Store/Product/ProductDetailAdd.vue";
import CartDetail from "@Scripts/Components/Store/Cart/CartDetail.vue";
import CartPreview from "@Scripts/Components/Store/Cart/CartPreview.vue";
import CheckoutProfileEdit from "@Scripts/Components/Store/Checkout/CheckoutProfileEdit.vue";
import CheckoutProfileMerge from "@Scripts/Components/Store/Checkout/CheckoutProfileMerge.vue";
import CheckoutSummary from "@Scripts/Components/Store/Checkout/CheckoutSummary.vue";

import NewsletterSubscribe from "@Scripts/Components/Newsletter/NewsletterSubscribe.vue";
import NewsletterUnsubscribe from "@Scripts/Components/Newsletter/NewsletterUnsubscribe.vue";
import RMAAssistance from "@Scripts/Components/RMAAssistance/RMAAssistance.vue";
import Satisfaction from "@Scripts/Components/Satisfaction/Satisfaction.vue";

import SearchBox from "@Scripts/Components/Search/SearchBox.vue";

export default class AppConfig {
    public static AddComponents() {
        Vue.component("app-accountlogin", AccountLogin);
        Vue.component("app-accountlogout", AccountLogout);
        Vue.component("app-accountregister", AccountRegister);
        Vue.component("app-accountedit", AccountEdit);
        Vue.component("app-accountemailconfirmsend", AccountEmailConfirmSend);
        Vue.component("app-accountpasswordremind", AccountPasswordRemind);
        Vue.component("app-accountpasswordreset", AccountPasswordReset);
        Vue.component("app-accountexternalregister", AccountExternalRegister);

        Vue.component("app-accountprofileedit", AccountProfileEdit);

        Vue.component("app-cookietoast", CookieToast);
        Vue.component("app-inforequest", InfoRequest);
        Vue.component("app-inforequestcta", InfoRequestCta);
        Vue.component("app-productdetailadd", ProductDetailAdd);
        Vue.component("app-cartdetail", CartDetail);
        Vue.component("app-cartpreview", CartPreview);
        Vue.component("app-checkoutprofileedit", CheckoutProfileEdit);
        Vue.component("app-checkoutprofilemerge", CheckoutProfileMerge);
        Vue.component("app-checkoutsummary", CheckoutSummary);

        Vue.component("app-newslettersubscribe", NewsletterSubscribe);
        Vue.component("app-newsletterunsubscribe", NewsletterUnsubscribe);

        Vue.component("app-rmaassistance", RMAAssistance);
        Vue.component("app-satisfaction", Satisfaction);

        Vue.component("app-searchbox", SearchBox);
    }

    public static AddDirectives() { }
}